import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { withStyles } from "@material-ui/core/styles";
import React, { Component } from "react";
import * as variables from "src/styles/variables.scss";

const StyledCheckbox = withStyles({
    checked: {},
    root: {
        "&$checked": {
            color: "#1b63dc",
        },
    },
})(Checkbox);

const StyledFormControlLabel = withStyles({
    label: {
        color: variables.colorDark,
        "font-size": "14px",
    },
})(FormControlLabel);

interface Props {
    name: string;
    label?: string;
    value?: boolean;

    onChange: (value: { target: { name: string; value: boolean } }) => void;
}

interface State {
    checked: boolean;
}

class FormCheckbox extends Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            checked: false,
        };
    }

    public componentDidMount() {
        const { value } = this.props;

        this.setState({
            checked: value || false,
        });
    }

    public render() {
        const { name, label } = this.props;
        const { checked } = this.state;

        return (
            <StyledFormControlLabel
                control={<StyledCheckbox name={name} checked={checked} onChange={this.handleChange} />}
                label={label}
            />
        );
    }

    private handleChange = (e: any) => {
        const val: boolean = e.target.checked;
        this.setState({ checked: val });
        this.props.onChange({
            target: { value: val, name: this.props.name },
        });
    };
}

export default FormCheckbox;
